export default {
  store: {
    state: {
      // isDeviceOnline: navigator.onLine,
      isOnline: navigator.onLine,
    },
    getters: {
      // isDeviceOnline: state => state.isDeviceOnline,
      isOnline: state => state.isOnline,
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/offline.js